import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth, API, consumeGuestReturnTo } from '../contexts/AuthContext';

function AuthCallback() {
  const navigate        = useNavigate();
  const { storeTokens } = useAuth();
  const called          = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code   = params.get('code');
    const error  = params.get('error');

    if (error || !code) {
      navigate(`/login?error=${error ?? 'oauth_failed'}`, { replace: true });
      return;
    }

    axios.post(`${API}/auth/exchange`, { code }, { withCredentials: true })
      .then(({ data }) => storeTokens(data.accessToken, data.refreshToken))
      .then((authedUser) => {
        navigate(consumeGuestReturnTo(authedUser?.id), { replace: true });
      })
      .catch(() => {
        // Auth itself failed (or profile fetch after it) — this session never claimed the
        // guest project, so drop any stale guest-return keys too.
        consumeGuestReturnTo();
        navigate('/login?error=token_invalid', { replace: true });
      });
  }, [navigate, storeTokens]);

  return (
    <div className="loading-screen">
      <div className="spinner" />
      <p>Signing you in…</p>
    </div>
  );
}

export default AuthCallback;
